export default "<div class=\"theme-winter no-bg\">\n  <router-outlet></router-outlet>\n</div>\n";